import { businessTabsInfo } from './offersTabsInfo/business';
import { insuranceTabsInfo } from './offersTabsInfo/insurance';
import { offersTabsInfo } from './offersTabsInfo/offers';
import { otherTabsInfo } from './offersTabsInfo/other';

export const OFFERS_TABS_WITHOUT_SUBPRODUCTS_INFO = {
  ...offersTabsInfo,
  ...businessTabsInfo,
  ...insuranceTabsInfo,
  ...otherTabsInfo,
};
